import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/logo_dark.png'


const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { class: "img-box" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  src: _imports_0
}
const _hoisted_6 = { class: "lang" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_9 = { class: "copyright" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:business@klicklpay.com" }, "business@klicklpay.com", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_popover = _resolveComponent("van-popover")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_Crypto = _resolveComponent("Crypto")!
  const _component_Fiat = _resolveComponent("Fiat")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["klickl-pay-defray", [_ctx.dev]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (['sunpaysandbox', 'sunpayprod'].includes(_ctx.dev))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: `${_ctx.BASE_URL}images/sunpay.png`,
                alt: "logo"
              }, null, 8, _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5))
        ]),
        _createVNode(_component_van_popover, {
          show: _ctx.showPopover,
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPopover = $event)),
          actions: _ctx.data.langs,
          theme: "dark",
          onSelect: _ctx.changeLang
        }, {
          reference: _withCtx(() => [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.convertLangName), 1)
          ]),
          _: 1
        }, 8, ["show", "actions", "onSelect"])
      ]),
      (_ctx.types == 0)
        ? (_openBlock(), _createBlock(_component_Crypto, {
            key: 0,
            modelValue: _ctx.types,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.types = $event)),
            info: _ctx.info,
            showCrypto: _ctx.showCrypto,
            showFiat: _ctx.showFiat,
            onClearRefRate: _ctx.clearRefRate
          }, {
            times: _withCtx(() => [
              (_ctx.refresh)
                ? (_openBlock(), _createBlock(_component_van_loading, {
                    key: 0,
                    color: "#1989fa",
                    size: "15px"
                  }))
                : _createCommentVNode("", true),
              _hoisted_7,
              _createVNode(_component_i18n_t, {
                keypath: "cashier.time",
                scope: "global"
              }, {
                s: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.time), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "info", "showCrypto", "showFiat", "onClearRefRate"]))
        : _createCommentVNode("", true),
      (_ctx.types == 1)
        ? (_openBlock(), _createBlock(_component_Fiat, {
            key: 1,
            modelValue: _ctx.types,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.types = $event)),
            info: _ctx.info,
            showCrypto: _ctx.showCrypto,
            showFiat: _ctx.showFiat,
            onClearRefRate: _ctx.clearRefRate
          }, {
            times: _withCtx(() => [
              (_ctx.refresh)
                ? (_openBlock(), _createBlock(_component_van_loading, {
                    key: 0,
                    color: "#1989fa",
                    size: "15px"
                  }))
                : _createCommentVNode("", true),
              _hoisted_8,
              _createVNode(_component_i18n_t, {
                keypath: "cashier.time",
                scope: "global"
              }, {
                s: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.time), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "info", "showCrypto", "showFiat", "onClearRefRate"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (!['sunpaysandbox', 'sunpayprod'].includes(_ctx.dev))
          ? (_openBlock(), _createBlock(_component_i18n_t, {
              key: 0,
              keypath: "defray.copyright",
              scope: "global"
            }, {
              mail: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}